import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { CtaBand } from "../components/CtaBand";
import { GALLERY } from "../data/site";

export default function Gallery() {
  return (
    <div data-testid="gallery-page">
      <PageHeader
        overline="Gallery"
        lines={["Trackside.", "Pit lane.", "Flat out."]}
        description="Scenes from the world ABS LLC works in — race cars, pit-lane operations, support crews, and the drivers at the center of it all."
      />

      <section data-testid="gallery-grid" className="border-t border-neutral-200 bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-24">
          <div className="columns-1 gap-5 sm:columns-2 lg:columns-3">
            {GALLERY.map((item, i) => (
              <Reveal key={item.src} delay={0.04 * (i % 3)} className="mb-5 break-inside-avoid">
                <figure
                  data-testid={`gallery-item-${i}`}
                  className={`group relative overflow-hidden ${i % 4 === 0 ? "clip-corner" : ""}`}
                >
                  <img
                    src={item.src}
                    alt={item.caption}
                    loading="lazy"
                    className="w-full object-cover grayscale-[0.6] transition-[filter,transform] duration-500 ease-out group-hover:scale-[1.03] group-hover:grayscale-0"
                  />
                  <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 bg-gradient-to-t from-black/70 to-transparent p-5 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                    <span className="text-sm font-medium text-white">{item.caption}</span>
                    <span className="font-overline shrink-0 text-[9px] uppercase tracking-[0.25em] text-[#ffb3ba]">
                      {item.tag}
                    </span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand title="Your car. Your weekend." accent="Our operation." />
    </div>
  );
}
